module.exports = __webpack_public_path__ + "static/media/chess-queen.33948014.svg";